module.exports = __webpack_public_path__ + "img/2.bd86bac0.jpg";